import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';

const SiteHealthListByNameHttpRequest = (() => {
  const apiName = 'siteHealthListByName';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `site-health/sites`;
  generatedHttpThunk.syntheticResponse = {};
  return generatedHttpThunk.generateSiteThunk();
})();

export default SiteHealthListByNameHttpRequest;
